import {HttpMethod, HttpService} from "./HttpService";
import {Transaction} from "../model/user/purchase/Transaction";

export interface Trace {
    traceType: string;
    source: string;
    pathname: string;
    timestamp: string;
    additionalInfo?: string;
    userAgent: string;
    platform: string;
    mobile: string;
    variation?: string;
    experimentId?: string;
    webinarDate?: string;
}

export interface AdminTransaction {
    id: string;
    createdAt: string;
    status: "STARTED" | "PAID" | "COMPLETED" | "CHARGEBACK";
    email: string;
    name: string;
    price: number;
    key: string;
    description: string;
    firstSource: string;
    source: string;
    traces?: Trace[];
    webinarId?: string;
    sessionId?: string;
}

export interface TransactionPage {
    items: AdminTransaction[];
    nextPageKey?: string;
}

export class TransactionService {

    public static getTransactions(): Promise<Transaction[]> {
        return HttpService.sendRequest<Transaction[]>(
            HttpMethod.GET,
            '/api/transaction',
        );
    }
    
    public static getAdminTransactions(pageKey?: string, filter: string = 'all'): Promise<TransactionPage> {
        let queryParams = '';
        if (pageKey && filter && filter !== 'all') {
            queryParams = `?nextPageKey=${encodeURIComponent(pageKey)}&filter=${encodeURIComponent(filter)}`;
        } else if (pageKey) {
            queryParams = `?nextPageKey=${encodeURIComponent(pageKey)}`;
        } else if (filter && filter !== 'all') {
            queryParams = `?filter=${encodeURIComponent(filter)}`;
        }
        return HttpService.sendRequest<TransactionPage>(
            HttpMethod.GET,
            `/api/admin/transactions${queryParams}`,
        );
    }
}